import { combineReducers } from 'redux'
import {
  IS_CART_INITIALISED,
  CART_INITIALISE,
  CART_EMPTIED,
  CART_FETCH,
  CART_REVIEWED,
  CART_COMPLETED,
  SET_ENTITLEMENT,
  SET_ACTIVE_CART_TAB,
  SET_TAXES,
  CART_PROCESSING,
  SET_CART_DOCKED,
  CYBERSOURCE_VALIDATED,
} from '../../constants'

const initialState = {
  isCartInitialised: false,
  isCartDocked: false,
  isCartReviewed: false,
  isCartCompleted: false,
  isCartProcessing: false,
  isCyberSourceValidated: false,
  cartId: '',
  items: [],
  subTotal: 0,
  taxes: {},
  entitlement: {},
  activeTab: '',
}

export const cartDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case IS_CART_INITIALISED:
      return {
        ...state,
        isCartInitialised: payload,
      }
    case SET_CART_DOCKED:
      return {
        ...state,
        isCartDocked: payload,
      }
    case CART_INITIALISE:
      return {
        ...state,
        cartId: payload.cart_id,
        subTotal: payload.subTotal,
      }
    case CART_EMPTIED:
      return {
        ...state,
        cartId: '',
        items: [],
        entitlement: {},
      }
    case CART_REVIEWED:
      return {
        ...state,
        isCartReviewed: payload.status,
      }
    case CART_COMPLETED:
      return {
        ...state,
        isCartCompleted: payload.status,
      }
    case CART_FETCH:
      return {
        ...state,
        items: payload,
      }
    case CYBERSOURCE_VALIDATED:
      return {
        ...state,
        isCyberSourceValidated: payload,
      }
    case SET_ENTITLEMENT:
      return {
        ...state,
        entitlement: payload,
      }
    case SET_ACTIVE_CART_TAB:
      return {
        ...state,
        activeTab: payload,
      }
    case SET_TAXES:
      return {
        ...state,
        taxes: payload.taxes,
        subTotal: payload.subTotal,
      }
    case CART_PROCESSING:
      console.log(payload)
      return {
        ...state,
        isCartProcessing: payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Cart/CartDetails/cartDetailsReducer.js